/**
 * MrRizz – lhůta na rozmyšlenou při odebrání položky z košíku.
 *
 * Kliknutí na koš se zachytí v capture fázi, takže Horizonův vlastní
 * handler vůbec nedostane slovo. Řádek se schová, na jeho místo se vloží
 * pruh s odpočtem. Když uživatel nic neudělá, klikne se na to samé
 * tlačítko znovu – tentokrát s příznakem, který interceptor pustí dál,
 * takže odebrání proběhne původní logikou motivu.
 */
(() => {
  const SELECTOR = '.cart-items__remove';
  const ROW = '.cart-items__table-row';

  const config = () => {
    const el = document.querySelector('[data-mr-undo-seconds]');
    return {
      seconds: Number(el?.dataset.mrUndoSeconds ?? 0),
      text: el?.dataset.mrUndoText || 'Produkt {produkt} byl odebrán.',
      button: el?.dataset.mrUndoButton || 'Vrátit zpět',
    };
  };

  function buildBar({ title, text, button, seconds }) {
    const tr = document.createElement('tr');
    tr.className = 'cart-undo-row';

    const td = document.createElement('td');
    td.colSpan = 6;
    td.className = 'cart-undo';

    const message = document.createElement('div');
    message.className = 'cart-undo__message';
    const [before, after] = text.split('{produkt}');
    message.append(before ?? '');
    const strong = document.createElement('strong');
    strong.textContent = title;
    message.append(strong, after ?? '');

    const track = document.createElement('div');
    track.className = 'cart-undo__track';
    const fill = document.createElement('span');
    fill.className = 'cart-undo__fill';
    fill.style.animationDuration = `${seconds}s`;
    track.append(fill);

    const undo = document.createElement('button');
    undo.type = 'button';
    undo.className = 'cart-undo__button';
    undo.textContent = button;

    const col = document.createElement('div');
    col.className = 'cart-undo__col';
    col.append(message, track);

    td.append(col, undo);
    tr.append(td);
    return { tr, undo };
  }

  // POZOR: musí být na window, ne na document.
  // Horizon si své on:click handlery věší na document v capture fázi a volá
  // stopImmediatePropagation(). Jeho skript se registruje dřív, takže posluchač
  // na documentu by se ke slovu nedostal. window capture běží ještě před ním.
  window.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const btn = target?.closest(SELECTOR);
      if (!btn) return;

      // Druhé kolo – potvrzené odebrání, pouštíme dál na Horizon.
      if (btn.dataset.mrConfirmed === '1') return;

      const { seconds, text, button } = config();
      if (!seconds) return;

      const row = btn.closest(ROW);
      if (!row || row.dataset.mrPending === '1') return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const title = row.querySelector('.cart-items__title')?.textContent.trim() ?? '';
      const { tr, undo } = buildBar({ title, text, button, seconds });

      // Pruh dostane přesnou výšku mizejícího řádku, ať stránka nepodskočí.
      // V CSS to natvrdo nejde – řádek roste s názvem i s hláškou o vzorku.
      tr.style.setProperty('--mr-undo-height', `${Math.round(row.getBoundingClientRect().height)}px`);

      row.dataset.mrPending = '1';
      row.style.display = 'none';
      row.after(tr);

      const timer = window.setTimeout(() => {
        tr.remove();
        btn.dataset.mrConfirmed = '1';
        btn.click();
      }, seconds * 1000);

      undo.addEventListener('click', () => {
        window.clearTimeout(timer);
        tr.remove();
        row.style.display = '';
        delete row.dataset.mrPending;
      });
    },
    true
  );
})();
